import Vue from 'vue';
import CryptoJS from 'crypto-js';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js';
import './services/GlobalVariables';
import DrawerLayout from 'vue-drawer-layout';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import VueToggles from 'vue-toggles';
import Loading from 'vue-loading-overlay';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as Sentry from "@sentry/vue";

// Register global components
Vue.component('loading', Loading);
Vue.component('VueToggles', VueToggles);
Vue.component('v-select', vSelect);

Vue.use(VueVirtualScroller);
Vue.use(DrawerLayout);

Vue.config.productionTip = false;
Sentry.init({
  Vue,
  dsn: "https://3e54851a7d8a8a7226400c4be6c38783@o4509145241550848.ingest.de.sentry.io/4509209547636816",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

Vue.prototype.$crypto = CryptoJS;
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
